<template>
    <div class="na-form">
        <div class="head">Status Detail</div>
        <div v-if="statusDetail" class="left">
            <DxTabPanel>
                <DxItem title="Base Data">
                    <div class="dx-fieldset">
                        <div class="dx-field">
                            <div class="dx-field-label">ID:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='statusDetail.StatusID' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Name:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='statusDetail.StatusName' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Technical Name:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='statusDetail.StatusName2' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Public Name:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='statusDetail.PublicName' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Short Name:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='statusDetail.Shortname' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Description:</div>
                            <div class="dx-field-value">
                                <DxTextArea v-model:value='statusDetail.Description' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Position:</div>
                            <div class="dx-field-value">
                                <DxNumberBox v-model:value='statusDetail.StaOrder' format="#" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Caption of Action Button:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='statusDetail.ActionButtonText' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Confirm Action:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='statusDetail.ConfirmAction' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Confirm 1. Notification:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='statusDetail.ConfirmMail' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Icon of Action Button:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='statusDetail.ActionButtonIcon' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Confirm Message of Action:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='statusDetail.ActionButtonMessage' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Caption of Delete Button:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='statusDetail.DeleteButtonText' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Icon of Delete Button:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='statusDetail.DeleteButtonIcon' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Confirm Message of Delete Button:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='statusDetail.DeleteButtonMessage' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Status Group:</div>
                            <div class="dx-field-value">
                                <DxSelectBox displayExpr="StgName" :dataSource="statusGroupList" valueExpr="StgId" v-model:value="statusDetail.StgId" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Add To Group:</div>
                            <div class="dx-field-value">
                                <DxSelectBox displayExpr="GrpName" :dataSource="groupList" valueExpr="GrpId" v-model:value="statusDetail.AddToGrpId" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Remove From Group:</div>
                            <div class="dx-field-value">
                                <DxSelectBox displayExpr="GrpName" :dataSource="groupList" valueExpr="GrpId" v-model:value="statusDetail.RemoveFromGrpId" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">1st Notification (confirmable):</div>
                            <div class="dx-field-value">
                                <DxSelectBox displayExpr="NevName" :dataSource="notificationSimpleList" valueExpr="NevId"
                                             showClearButton="true" v-model:value="statusDetail.NevId" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">2nd Notification:</div>
                            <div class="dx-field-value">
                                <DxSelectBox displayExpr="NevName" :dataSource="notificationSimpleList" valueExpr="NevId"
                                             showClearButton="true" v-model:value="statusDetail.NevId2" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">3rd Notification:</div>
                            <div class="dx-field-value">
                                <DxSelectBox displayExpr="NevName" :dataSource="notificationSimpleList" valueExpr="NevId"
                                             showClearButton="true" v-model:value="statusDetail.NevId3" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">1st third person Notification (confirmable):</div>
                            <div class="dx-field-value">
                                <DxSelectBox displayExpr="NevName" :dataSource="notificationSimpleList" valueExpr="NevId"
                                             showClearButton="true" v-model:value="statusDetail.ThirdPersonNevId" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">2nd third person Notification:</div>
                            <div class="dx-field-value">
                                <DxSelectBox displayExpr="NevName" :dataSource="notificationSimpleList" valueExpr="NevId"
                                             showClearButton="true" v-model:value="statusDetail.ThirdPersonNevId2" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">3rd third person Notification:</div>
                            <div class="dx-field-value">
                                <DxSelectBox displayExpr="NevName" :dataSource="notificationSimpleList" valueExpr="NevId"
                                             showClearButton="true" v-model:value="statusDetail.ThirdPersonNevId3" />
                            </div>
                        </div>
                        <!--<div class="dx-field">
                            <div class="dx-field-label">Standard for following Status:</div>
                            <div class="dx-field-value">
                                <DxSelectBox displayExpr="StatusName" :dataSource="statusList" valueExpr="StatusID" showClearButton="true" v-model:value="statusDetail.StatusIdNextDefault" />
                            </div>
                        </div>-->
                        <div class="dx-field">
                            <div class="dx-field-label">Owner generally has read permission:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='statusDetail.OwnerRead' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Owner generally has write permission:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='statusDetail.OwnerWrite' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Owner generally has status change permission:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='statusDetail.OwnerChangeStatus' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Select assignee from group after status change:</div>
                            <div class="dx-field-value">
                                <DxSelectBox displayExpr="GrpName" showClearButton="true"
                                             :dataSource="groupList" valueExpr="GrpId" v-model:value="statusDetail.AssigneeGrpId" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Status Change without assigning new assignee:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='statusDetail.NoAssigneeStatus' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Set the Author as the Assignee:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='statusDetail.OwnerStatus' />
                            </div>
                        </div>
                        <!--<div class="dx-field">
                            <div class="dx-field-label">Show in Review Lists:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='statusDetail.ReviewStatus' />
                            </div>
                        </div>-->
                        <!--<div class="dx-field">
                            <div class="dx-field-label">Status Change With Comment:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='statusDetail.WithWFComment' />
                            </div>
                        </div>-->
                        <!--<div class="dx-field">
                            <div class="dx-field-label">Status change with email notification:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='statusDetail.NotifyOnAssigned' />
                            </div>
                        </div>-->
                        <div class="dx-field">
                            <div class="dx-field-label">Created On:</div>
                            <div class="dx-field-value">
                                <DxDateBox :value='statusDetail.CreatedOn' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Created By:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='statusDetail.CreatedBy' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Changed On:</div>
                            <div class="dx-field-value">
                                <DxDateBox :value='statusDetail.ChangedOn' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Changed By:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='statusDetail.ChangedBy' :readOnly="true" />
                            </div>
                        </div>
                    </div>
                </DxItem>
                <DxItem title="Permissions">
                    <DxDataGrid id="tsAccessList"
                                :data-source="accessListForStatus"
                                key-expr="GrpId"
                                :remote-operations="false"
                                :allow-column-resizing="true"
                                :allow-column-reordering="true"
                                @exporting="onExporting"
                                :row-alternation-enabled="true"
                                :show-borders="true">
                        <DxColumn data-field="GrpId" caption="Gruppe" data-type="number" :allowEditing="false" :width="120" :visible="true" />
                        <DxColumn data-field="GrpName" caption="User Group" data-type="string" />
                        <DxColumn caption="Permissions">

                            <DxColumn caption="Status Change" data-type="string">
                                <!--<DxColumn caption="Visible (1)" data-field="CanView" data-type="boolean"></DxColumn>-->
                                <DxColumn caption="Can Set Status" data-field="CanChangeStatus" data-type="boolean"></DxColumn>
                                <DxColumn caption="Owner Can Set Status" data-field="CanOwnerChangeStatus" data-type="boolean"></DxColumn>
                                <DxColumn caption="Assignee Can Set Status" data-field="CanAssigneeChangeStatus" data-type="boolean"></DxColumn>
                                <DxColumn caption="Group Member Can Change Status" data-field="CanGroupChangeStatus" data-type="boolean" />
                            </DxColumn>
                            <DxColumn caption="Read" data-type="string">
                                <DxColumn data-field="CanRead" caption="Visible" data-type="boolean" />
                                <DxColumn data-field="CanOwnerRead" caption="Owner Read" data-type="boolean" />
                                <DxColumn data-field="CanAssigneeRead" caption="Assignee Read" data-type="boolean" />
                                <DxColumn data-field="CanGroupRead" caption="Group Read" data-type="boolean" />
                            </DxColumn>
                            <DxColumn caption="Write" data-type="string">
                                <DxColumn data-field="CanUpdate" caption="Updateable" data-type="boolean" />
                                <DxColumn data-field="CanOwnerWrite" caption="Owner Write" data-type="boolean" />
                                <DxColumn data-field="CanAssigneeWrite" caption="Assignee Write" data-type="boolean" />
                                <DxColumn data-field="CanGroupWrite" caption="Group Write" data-type="boolean" />
                            </DxColumn>
                            <DxColumn data-field="CanInsert" caption="Create" data-type="boolean" />
                            <DxColumn data-field="CanDelete" caption="Delete" data-type="boolean" />
                        </DxColumn>
                        <DxLoadPanel :enabled="true" />
                        <DxScrolling mode="virtual" />
                        <DxColumnChooser :enabled="true" />
                        <DxColumnFixing :enabled="true" />
                        <DxFilterRow :visible="true" />
                        <DxEditing :allow-updating="true"
                                   :allow-adding="false"
                                   :allow-deleting="false"
                                   select-text-on-edit-start="true"
                                   start-edit-action="click"
                                   mode="cell" />
                        <DxHeaderFilter :visible="true" />
                        <DxSearchPanel :visible="true"
                                       :width="240"
                                       placeholder="Search..." />
                        <DxExport :enabled="true"
                                  :allow-export-selected-data="true" />
                        <template #headerTemplate="{ data }">
                            <div class="tsHeaderCell">{{data.column.caption}}</div>
                        </template>
                        <template #cellTemplate="{ data }">
                            <div class="tsCell">{{data.value}}</div>
                        </template>
                    </DxDataGrid>
                </DxItem>
            </DxTabPanel>
            <div class="na-buttons-row">
                <div>
                    <DxButton :width="120"
                              text="Update"
                              :type="saveButtonType"
                              :disabled="saveButtonDisabled"
                              styling-mode="contained"
                              @click="onSaveClick($event)" />
                </div>
                <div>
                    <DxButton :width="120"
                              text="Delete"
                              type="danger"
                              styling-mode="contained"
                              @click="onDeleteClick($event)" />
                </div>

                <div>
                    <DxButton :width="120"
                              text="Back"
                              styling-mode="contained"
                              @click="onCancelClick($event)" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { DxTextBox } from 'devextreme-vue/text-box'
    import { DxTextArea } from 'devextreme-vue/text-area'
    import { DxButton } from 'devextreme-vue/button'
    import { DxSelectBox } from 'devextreme-vue/select-box'
    import { DxNumberBox } from 'devextreme-vue/number-box'
    import { DxDateBox } from 'devextreme-vue/date-box'
    import { DxCheckBox } from 'devextreme-vue/check-box'
    import { DxTabPanel, DxItem } from 'devextreme-vue/tab-panel'
    import { DxDataGrid, DxColumn, DxEditing } from 'devextreme-vue/data-grid'
    import { confirm } from "devextreme/ui/dialog"
    import notify from 'devextreme/ui/notify'
    import $ from 'jquery'

    import { exportDataGrid } from 'devextreme/excel_exporter';
    import { Workbook } from 'exceljs';
    import saveAs from 'file-saver';

    export default {
        name: 'StatusDetail',
        components: {
            DxButton,
            DxTextBox,
            DxTextArea,
            DxDateBox,
            DxCheckBox,
            DxNumberBox,
            DxSelectBox,
            DxTabPanel,
            DxItem,
            DxDataGrid,
            DxColumn,
            DxEditing
        },
        data() {
            return {
                post: null,
                files: [],
                isSaving: false
            };
        },
        props: {
            statusId: {
                type: [Number],
                required: true,
                default: 0
            },
            newWorId: {
                type: [Number],
                required: true,
                default: 0
            },
        },
        watch: {
            worId: function (newVal, oldVal) {
                if (newVal != oldVal && newVal >= 0) {
                    this.$store.dispatch("getStatusListSimple", { worId: newVal })
                }
            },
            statusDetailText: function (newVal, oldVal) {
                if (oldVal != "{}" && oldVal != newVal) {
                    this.$store.state.statusStore.statusDetailChanged = true
                }
            },
            accessListForStatusText: function (newVal, oldVal) {
                if (oldVal != "[]" && oldVal != newVal) {
                    this.$store.state.statusStore.accessListForStatusChanged = true
                }
            },
            changed: function (newVal) {
                if (!newVal && this.isSaving) {
                    this.isSaving = false
                    notify("The changes were saved successfully")
                }
            },
        },
        created: function () {
        },
        mounted: function () {
            this.$store.dispatch("getStatusDetail", { statusId: this.statusId, worId: this.newWorId })
            this.$store.dispatch("getStatusGroupListSimple")
            this.$store.dispatch("getGroupListSimple")
            this.$store.dispatch("getNotificationSimpleList")
            this.$store.dispatch("getPresentationGroupListSimple")
            this.$store.dispatch("getAccessListForStatus", { statusId: this.statusId })
        },
        computed: {
            groupList() {
                return this.$store.state.groupStore.groupListSimple
            },
            statusList() {
                return this.$store.state.statusStore.statusListSimple
            },
            notificationSimpleList() {
                return this.$store.state.notificationEventStore.notificationSimpleList
            },
            accessListForStatus() {
                return this.$store.state.statusStore.accessListForStatus
            },
            accessListForStatusText() {
                return JSON.stringify(this.$store.state.statusStore.accessListForStatus)
            },
            statusGroupList() {
                return this.$store.state.statusGroupStore.statusGroupListSimple
            },
            presentationGroupList() {
                return this.$store.state.presentationStore.presentationGroupListSimple
            },
            statusDetail() {
                return this.$store.state.statusStore.statusDetail
            },
            statusDetailText() {
                return JSON.stringify(this.$store.state.statusStore.statusDetail)
            },
            worId() {
                return this.$store.state.statusStore.statusDetail.WorId
            },
            saveButtonType() {
                return this.changed
                    ? "success" : "normal"
            },
            saveButtonDisabled() {
                return this.changed
                    ? false : true
            },
            changed() {
                return this.$store.state.statusStore.statusDetailChanged
                    || this.$store.state.statusStore.accessListForStatusChanged
            }
        },
        methods: {
            onExporting(e) {
                e.component.beginUpdate();
                const workbook = new Workbook();
                const worksheet = workbook.addWorksheet('Data');
                exportDataGrid({
                    component: e.component,
                    worksheet: worksheet
                }).then(function () {
                    workbook.xlsx.writeBuffer().then(function (buffer) {
                        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Data.xlsx');
                    });
                }).then(function () {
                    e.component.endUpdate();
                });
            },
            onCancelClick() {
                $("form").attr("action", window.location.pathname + "?action=cancel").submit();
            },
            onSaveClick() {
                this.isSaving = true
                this.$store.dispatch("saveStatusDetail")
                this.$store.dispatch("saveAccessListForStatus")
            },
            onDeleteClick() {
                let result = confirm("Sind Sie sicher, dass Sie den Status löschen möchten? Ein Löschen ist nicht möglich, wenn bereits verknüpfte Datensätze bestehen", "Löschen bestätigen");
                result.then((dialogResult) => {
                    if (dialogResult) {
                        var result2 = this.$store.dispatch("deleteStatus", { statusId: this.statusId })
                        result2.then(() => {
                            $("form").attr("action", window.location.pathname + "?action=cancel").submit();
                        });
                    }
                });
            },
        }
    }
</script>
<style>

    div {
        text-align: left;
    }

    .options {
        margin-top: 20px;
        padding: 20px;
        background-color: rgba(191, 191, 191, 0.15);
        box-sizing: border-box;
        width: 100%;
    }

    .html-dx-field {
        width: 700px;
        height: 300px;
    }

    .html-label {
        padding-right: 200px
    }
</style>
